import { T } from "@/lib/i18n";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { googleSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// One exchange per session_id, even when the effect runs twice (React StrictMode).
const exchanges = new Map();
const exchangeOnce = (sid) => {
  if (!exchanges.has(sid)) exchanges.set(sid, googleSession(sid));
  return exchanges.get(sid);
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await exchangeOnce(sessionId);
        await refreshUser();
        toast.success(T("Login effettuato con Google"));
        window.history.replaceState({}, "", "/");
        navigate("/");
      } catch (e) {
        toast.error(T("Login Google fallito"));
        navigate("/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-[#10b981] font-mono text-sm">
      <div className="text-center">
        <div className="animate-pulse">{T("▸ Autenticazione in corso...")}</div>
      </div>
    </div>
  );
}
